import { render, staticRenderFns } from "./EditCommunityButton.vue?vue&type=template&id=3ff63518&scoped=true"
import script from "./EditCommunityButton.vue?vue&type=script&lang=js"
export * from "./EditCommunityButton.vue?vue&type=script&lang=js"
import style0 from "./EditCommunityButton.vue?vue&type=style&index=0&id=3ff63518&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff63518",
  null
  
)

export default component.exports